import  { useState, useEffect } from "react";
import {
    Box,
    Button,    
    Grid,    
    Autocomplete,
    TextField,
    Divider,
    Typography,
} from "@mui/material";
import {  Toolbar, } from '@mui/material';


import CallAlertBar from "../../../Layout/Alertbar";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import Header from "../../../Layout/Header";
const LeaveBalanceEntry = ({ handleOpenLeaveBalanceList, SelectedEmployeeleaveBalance }) => {

    const [checkInTime, setCheckInTime] = useState(null);
    const [checkOutTime, setCheckOutTime] = useState(null);
    const [durationMins, setDurationMins] = useState(0);

    
    const [employeeID, setEmployeeID] = useState("");
   
    const [errorMessages, setErrorMessages] = useState({});
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');
    const [employee, setEmployee] = useState('');
    const [employeelist, setEmployeelist] = useState([]);
   

    const [title, setTitle] = useState('Employee Leave Balance Entry');
    const [disableEmployee, setdisableEmployee] = useState(false);
    const [disabledEmployeeDetails, setdisabledEmployeeDetails] = useState(false);
    const [leaveType, setLeaveType] = useState("");
    const [employeeleavetype, setEmployeeleavetype] = useState([]);
    const [leaveTypeID, setLeaveTypeID] = useState("");


    const [allocatedDays, setAllocatedDays] = useState('');
    const [usedDays, setUsedDays] = useState('');
   



    const ViewHideMsg = (msg, securityvalue, open) => {
        setParentRollSeverityvalue(securityvalue);
        setParentRollMessageValue(msg);
        setParentRollAlertTitleValue(securityvalue);
        setParentRollMsgOpen(open);
    }

    const validateEmployeeLeaveBalance = () => {

        const errors = {};
        if (!employeeID) {
            ViewHideMsg("Employee is required.", 'warning', true);
            errors.employeeID = "Employee is required.";
        } else if (!leaveTypeID) {
            ViewHideMsg("Leave type is required.", 'warning', true);
            errors.attendanceDate = "Leave type is required.";
        } else if (!allocatedDays) {
            ViewHideMsg("Allocated days is required.", 'warning', true);
            errors.checkInTime = "Allocated days is required.";
        }


        return errors;
    };

    const handleSubmit = () => {
        const errors = validateEmployeeLeaveBalance();

        if (Object.keys(errors).length > 0) {
            setErrorMessages(errors);
            return;
        }

        const requestBody = {
            id_employee: employeeID,
            id_leave_type: leaveTypeID,
            allocated_days: allocatedDays,
            used_days: usedDays,
        };

        callApi(API_ENDPOINTS.EMPLOYEE_InsertAndUpdateEmployeeLeaveBalance, 'POST', { 'Content-Type': 'application/json' }, requestBody)
            .then(data => {
                if (data !== null) {
                    setParentRollMessageValue(data);
                    setParentRollSeverityvalue('info');
                    setParentRollAlertTitleValue('Info');
                    setParentRollMsgOpen(true);
                }
                else {
                    setParentRollSeverityvalue('error');
                    setParentRollMessageValue(data);
                    setParentRollAlertTitleValue('Error');
                    setParentRollMsgOpen(true);
                }
            })
            .catch(error => {
                // // Update state with error message        
                setParentRollSeverityvalue('error');
                setParentRollMessageValue(error.message);
                setParentRollAlertTitleValue('Error');
                setParentRollMsgOpen(true);
            });
    };

    const handleEmployeeChange = (event, value) => {
        if (value) {
            setEmployee(value);
            setEmployeeID(value.id);
        }
        else {
            setEmployee('');
            setEmployeeID('');
        }
    }

    useEffect(() => {
        const params = { p_companyid: localStorage.getItem('companyid') };

        callApi(API_ENDPOINTS.EMPLOYEE_GetEmployeeLists, 'POST', { 'Content-Type': 'application/json' }, params)
            .then(data => {
                if (data?.length) {
                    setEmployeelist(data);
                }
            })
            .catch(error => alert(error.message));


        callApi(API_ENDPOINTS.EMPLOYEE_LEAVE_TYPE, 'POST', { 'Content-Type': 'application/json' }, params)
            .then(data => {
                if (data?.length) {
                    setEmployeeleavetype(data);
                }
            })
            .catch(error => alert(error.message));
    }, []);



    



    useEffect(() => {
        if (SelectedEmployeeleaveBalance.length>0 && employeelist.length > 0 && employeeleavetype.length > 0) {

            const EmployeeDetails = employeelist.find(user => user.name === SelectedEmployeeleaveBalance[0].employee_name);
            setEmployee(EmployeeDetails);

            const EmployeeLeaveType = employeeleavetype.find(user => user.leavetype === SelectedEmployeeleaveBalance[0].leave_type);
            setLeaveType(EmployeeLeaveType);

            setEmployeeID(EmployeeDetails.id);
            setLeaveTypeID(EmployeeLeaveType.id);
        
            setdisabledEmployeeDetails(true);

            setAllocatedDays(SelectedEmployeeleaveBalance[0].allocated_days);
            setUsedDays(SelectedEmployeeleaveBalance[0].used_days);
           

        }

    }, [employeelist, employeeleavetype, SelectedEmployeeleaveBalance]);


    const ClearAll = async () => {
        // Assuming you might have asynchronous operations in the future
        try {
            setEmployee('');
            setEmployeeID('');
            setLeaveType('');
            setLeaveTypeID('');
            setAllocatedDays('');
            setUsedDays('');

            setdisableEmployee(false);

            setParentRollMsgOpen(false);
        } catch (error) {
            console.error('Error during ClearAll:', error);

        }
    };





    const handleEmployeeLeaveTypeChange = (event, value) => {
        if (value) {
            setLeaveType(value);
            setLeaveTypeID(value.id);
        }
        else {
            setLeaveType('');
            setLeaveTypeID('');
        }
    }

    return (
        <Box padding={0}>
            <Header title={title} subtitle='' callback={handleOpenLeaveBalanceList} />
            <Divider />

            {/* Message box detail */}
            <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />


            <Box>
                <Grid container spacing={2} padding={3}>
                    <Grid container padding="10px 0px 20px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                        <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                            <Typography variant="h6">Employee Name</Typography>
                        </Grid>
                        <Grid item xs={12} sm={11} md={4.1} lg={4.1} xl={4.1}>
                            <Autocomplete
                                fullWidth
                                value={employee}
                                onChange={handleEmployeeChange}
                                size="small"
                                style={{ fontSize: '12px' }}
                                options={employeelist}
                                getOptionLabel={(option) => option?.name || ''}
                                disabled={disabledEmployeeDetails}
                                renderInput={(params) =>
                                    <TextField required
                                        disabled={disabledEmployeeDetails}

                                        {...params} variant="outlined" />}
                            />
                        </Grid>
                    </Grid>


                    <Grid container padding="10px 0px 20px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                        <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                            <Typography variant="h6">Leave Type</Typography>
                        </Grid>
                        <Grid item xs={12} sm={11} md={4.1} lg={4.1} xl={4.1}>
                            <Autocomplete
                                fullWidth
                                value={leaveType}
                                onChange={handleEmployeeLeaveTypeChange}
                                size="small"
                                style={{ fontSize: '12px' }}
                                options={employeeleavetype}
                                getOptionLabel={(option) => option?.leavetype || ''}
                                disabled={disabledEmployeeDetails}
                                renderInput={(params) =>
                                    <TextField required
                                        disabled={disabledEmployeeDetails}
                                        // helperText={errorMessage}
                                        // error={errorMessage && errorMessage.length ? true : false}
                                        {...params} variant="outlined" />}
                            />
                        </Grid>
                    </Grid>


                    <Grid container padding="5px 0px 20px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} >
                        <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                            <Typography variant="h6">Allocated Days</Typography>
                        </Grid>
                        <Grid item xs={12} sm={11} md={4.1} lg={4.1} xl={4.1}>
                            <TextField

                                fullWidth
                                type="number"
                                value={allocatedDays}
                                onChange={(e) => setAllocatedDays(e.target.value)}
                                size="small"
                                required
                            />
                        </Grid>
                    </Grid>

                    <Grid container padding="5px 0px 20px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} >
                        <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                            <Typography variant="h6">Used Days</Typography>
                        </Grid>
                        <Grid item xs={12} sm={11} md={4.1} lg={4.1} xl={4.1}>
                            <TextField

                                fullWidth
                                type="number"
                                value={usedDays}
                                onChange={(e) => setUsedDays(e.target.value)}
                                size="small"

                            />
                        </Grid>
                    </Grid>




                </Grid>

                <Box justifyContent={'space-between'} sx={{
                    position: 'fixed',
                    bottom: 0,
                    width: '100%'
                }}>
                    <Divider style={{ backgroundColor: '' }} />
                    <Toolbar >
                        <Button variant='contained' style={{ fontSize: '12px', marginRight: '8px', textTransform: 'none', backgroundColor: '#1769aa' }} onClick={handleSubmit} type="Submit">
                            Save
                        </Button>

                        <Button
                            onClick={ClearAll}
                            variant='contained'
                            style={{ marginRight: '0px', fontSize: '12px', backgroundColor: '#c5c7c6', color: 'black', textTransform: 'none', }} //borderRadius:'5px 5px 0px 5px'
                        >
                            Clear
                        </Button>
                    </Toolbar>
                </Box>
            </Box>
        </Box>
    );
};

export default LeaveBalanceEntry;
